import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ar from './ar.json';

export const SUPPORTED_LANGUAGES = ['en', 'ar'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const LANG_STORAGE_KEY = 'dda-lang';

function isLanguage(value: string | null): value is Language {
  return value === 'en' || value === 'ar';
}

function readStoredLanguage(): Language {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    if (isLanguage(stored)) return stored;
  } catch {
    /* ignore */
  }
  return 'en';
}

/** Sync <html dir/lang> with the active language (RTL for Arabic). */
export function applyDocumentLanguage(lang: Language): void {
  const root = document.documentElement;
  root.setAttribute('lang', lang);
  root.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: readStoredLanguage(),
  fallbackLng: 'en',
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on('languageChanged', (lang) => {
  if (isLanguage(lang)) applyDocumentLanguage(lang);
});

// Ensure the document reflects the initial language on first load.
applyDocumentLanguage(readStoredLanguage());

export default i18n;
